var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_017e6569"]},_vm.$listeners),[_c('div',{class:["cube-single-loading"]},[_c('span',{class:["cube-loading-spinners"],style:(_vm._f("transRpxStyle")([(_vm.style)]))},_vm._l(((_vm.line)),function(item,index){return _c('span',{class:["cube-loading-spinner"]})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }